var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M24.5 11.132l-.877-.863c-4.089-4.025-10.726-4.025-14.815 0a10.157 10.157 0 000 14.529L24.5 40.246l15.692-15.448a10.157 10.157 0 000-14.529c-4.089-4.025-10.726-4.025-14.815 0l-.877.863zM24.5 42L7.931 25.689c-4.575-4.504-4.575-11.807 0-16.311s11.993-4.504 16.569 0c4.575-4.504 11.993-4.504 16.569 0s4.575 11.807 0 16.311L24.5 42z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OSIgaGVpZ2h0PSI0OCIgdmlld0JveD0iMCAwIDQ4IDQ4IiBmaWxsPSJub25lIiB4bWxuczp2PSJodHRwczovL3ZlY3RhLmlvL25hbm8iPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTI0LjUgMTEuMTMybC0uODc3LS44NjNjLTQuMDg5LTQuMDI1LTEwLjcyNi00LjAyNS0xNC44MTUgMC00LjA3OCA0LjAxNC00LjA3OCAxMC41MTUgMCAxNC41MjlMMjQuNSA0MC4yNDZsMTUuNjkyLTE1LjQ0OGM0LjA3OC00LjAxNCA0LjA3OC0xMC41MTUgMC0xNC41MjktNC4wODktNC4wMjUtMTAuNzI2LTQuMDI1LTE0LjgxNSAwbC0uODc3Ljg2M3pNMjQuNSA0Mkw3LjkzMSAyNS42ODljLTQuNTc1LTQuNTA0LTQuNTc1LTExLjgwNyAwLTE2LjMxMXMxMS45OTMtNC41MDQgMTYuNTY5IDBjNC41NzUtNC41MDQgMTEuOTkzLTQuNTA0IDE2LjU2OSAwczQuNTc1IDExLjgwNyAwIDE2LjMxMUwyNC41IDQyeiIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9zdmc+";
export { SvgHeart as ReactComponent };